import axios from 'axios';

export default {
  get: (params) => axios.get('/api/v1/qr-management', { params }),
  getForUser: (id) => axios.get(`/api/v1/qr-management-user/${id}`),
  getById: (id) => axios.get(`/api/v1/qr-management/${id}`),
  post: (params) => axios.post('/api/v1/qr-management', params),
  delete: (params) => axios.delete('/api/v1/qr-management', { params }),
};
